import { useEffect, useState } from "react";
import WOW from 'wowjs';
import Header from "../components/Header";
import Footer from "../components/Footer";

import asilo from '../../../assets/img/asilo.jpg';

const SolicitudAsiloPage = () => {

    const [open, setOpen] = useState(false);
    const [visible, setVisible] = useState(true);

    const openModal = () => setOpen(true);
    const closeModal = () => setOpen(false);

    useEffect(() => {
        new WOW.WOW().init();
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const handleClick = ({
        phone = "16892589039",
        message = "Hola, quiero más información",
    }) => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;

        const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

        // URL de WhatsApp
        const whatsappURL = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}&app_absent=0`;

        // En iOS Safari, abrir directamente
        if (isIOS) {
            window.location.href = whatsappURL;
        } else {
            window.open(whatsappURL, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <>
            <Header currentSection='solicitud-asilo' />
            <section id='solicitud-asilo' className="solicitud-asilo w-100 pt-130" style={{ background: "linear-gradient(rgba(249, 249, 249, 1), rgba(249, 249, 249, 1))" }}>
                <div className='container d-flex flex-column justify-content-center align-items-center'>
                    <div className="info-card">

                        <div className="banner">
                            <img src={asilo} alt="Solicitud de asilo" className="banner-img" />
                            <div className="overlay"></div>

                            <div className="banner-text">
                                <h2>¿Qué es el Asilo y Quién Puede Solicitarlo?</h2>
                                <p>Asilo a tu Alcance te guia paso a paso para que puedas solicitar asilo</p>
                                <button className="btn-ver-video d-flex justify-content-center align-items-center" onClick={openModal}>
                                    Ver video 
                                    <span className="bi bi-play fs-3"></span>
                                </button>
                            </div>
                        </div>

                        {/* <h2 className="info-card__title fw-bold">¿Qué es el Asilo y Quién Puede Solicitarlo?</h2> */}
                        <p className="info-card__text mt-2">
                            El asilo es un programa de protección internacional en los Estados Unidos que brinda refugio y seguridad a personas
                            que temen ser perseguidas o dañadas en sus países de origen.
                        </p>
                        <p className="info-card__text">La protección se otorga si el temor fundado de persecución se debe a:
                            <strong> raza, religión, nacionalidad, opinión política o pertenencia a un grupo social específico.</strong>
                        </p>

                        <h3 className="info-card__subtitle">Requisitos Clave:</h3>
                        <ul className="info-card__list">
                            <li>Temor Fundado de Persecución: Debe existir una base sólida para temer el daño por las razones protegidas.</li>
                            <li>Límite de Tiempo (Regla de 1 Año): La solicitud debe presentarse generalmente dentro de un año de tu llegada a EE. UU., salvo excepciones justificadas.</li>
                            <li>Elegibilidad: Debes ser apto para ingresar al país y no tener antecedentes de delitos graves.</li>
                        </ul>

                        <h3 className="info-card__subtitle">Tipos de Asilo en EE. UU.</h3>
                        <p className="info-card__text">Existen dos vías principales para solicitar protección:</p>
                        <p className="info-card__text">
                            <strong> Asilo Afirmativo: </strong> Para quienes no están bajo un proceso de deportación. La solicitud se presenta directamente ante la oficina del USCIS. Si se niega, el caso se refiere a la corte para un proceso defensivo.
                        </p>
                        <p className="info-card__text">
                            <strong> Asilo Defensivo: </strong> Para quienes ya se encuentran en un proceso de deportación. La solicitud se presenta y se defiende ante un Juez de Inmigración.
                        </p>

                        <h3 className="info-card__subtitle">Beneficios Cruciales del Asilo</h3>
                        <p className="info-card__text">
                            La concesión del asilo te otorga un estatus legal que conlleva múltiples beneficios esenciales:
                        </p>
                        <ul className="info-card__list">
                            <li><strong>Estatus Legal:</strong> Permanencia y derecho a vivir y trabajar en EE. UU.</li>
                            <li><strong>Permiso de Trabajo (EAD):</strong> Recibirás autorización legal para buscar empleo.</li>
                            <li><strong>Reunificación Familiar:</strong> Podrás solicitar que tu cónyuge e hijos solteros menores de 21 años se reúnan contigo en EE. UU.</li>
                            <li><strong>Acceso a Beneficios:</strong> Obtener asistencia monetaria, médica y de integración (como clases de inglés y orientación laboral).</li>
                            <li><strong>Residencia Permanente:</strong> Tienes la opción de solicitar la Green Card después de un año y un día de obtener el asilo.</li>
                        </ul>

                        <h3 className="info-card__subtitle">Proceso y Tiempos</h3>
                        <p className="info-card__text">
                            El proceso implica presentar la solicitud formal, demostrar la elegibilidad con evidencia sólida de persecución y, finalmente, participar en una entrevista (USCIS) o una audiencia (Juez de Inmigración).
                        </p>
                        <p className="info-card__text">
                            Los tiempos son variables, pudiendo extenderse de meses a años dependiendo de la ubicación, la carga de trabajo y el tipo de proceso (afirmativo o defensivo).
                        </p>

                        <h3 className="info-card__subtitle">Preparación y Documentación</h3>
                        <p className="info-card__text">
                            Es vital reunir todas las evidencias (informes, amenazas, registros médicos) que respalden tu temor fundado y contar con documentos de identificación vigentes. Siempre prepárate para la entrevista o audiencia revisando tus documentos a fondo.
                        </p>

                        <h3 className="info-card__subtitle">¿Qué puede pasar con mi caso?</h3>
                        <p className="info-card__text">
                            <strong>Si es concedido:</strong> Obtienes el estatus de asilado y la posibilidad de solicitar la Residencia Permanente al año siguiente. <br />
                            <strong>Si es denegado:</strong> Enfrentas la posibilidad de deportación o salida voluntaria. Tienes la opción de apelar la decisión ante un tribunal de inmigración o, en ciertos casos, presentar una reconsideración. Una denegación no es el fin del camino.
                        </p>

                        <div className="info-card__subtitle fw-bold text-center">
                            Nuestros asesores expertos están aquí para guiarte en cada etapa de este proceso complejo, protegiendo tus derechos y luchando por tu seguridad.
                        </div>
                    </div>

                    <button onClick={handleClick} className="border-0 text-white text-decoration-none px-3 py-3 rounded-4 text-center wow bounce shadow-md z-1 bg-secondary" style={{ fontSize: '1.1rem' }}>
                        <i className="bi bi-whatsapp"></i> Solicita mas información
                    </button>
                    <div className='mb-5'></div>

                </div>
            </section>
            {open && (
                <div className="modal-video" onClick={closeModal}>
                    <div
                        className="modal-video-content"
                        onClick={(e) => e.stopPropagation()} // evita cerrar al hacer clic dentro
                    >
                        <span className="cerrar" onClick={closeModal}>
                            &times;
                        </span>
                        <iframe
                            width="315"
                            height="560"
                            src="https://www.youtube.com/embed/cicfkhx0S3Q?autoplay=1"
                            title="Video de YouTube"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            )}
            <Footer />
            <div className="chat-container">
                {visible && (
                    <div className="chat-popup">
                        <div className="chat-text">
                            <strong>Asilo a tu Alcance</strong><br />
                            ¡Hola! Soy tu asesor de Inmigración. ¿Cómo te puedo ayudar?
                        </div>
                        <span className="close-btn" onClick={() => setVisible(false)}>×</span>
                    </div>
                )}
                <div className="chat-icon">
                    <button onClick={handleClick} className="border-0 btn-wsp d-flex align-items-center justify-content-center">
                        <i className="bi bi-whatsapp icono"></i>
                    </button>
                </div>
            </div>
        </>
    );
}

export default SolicitudAsiloPage;